/* Handling of mission related state */
import {
  GET_MISSION_SUCCESS,
  GET_MISSION_QUESTIONS_SUCCESS,
  RESET_QUESTIONS
} from '@stores/mutation-types';

import {
  Main as Mission
} from '@services/App/mission';

import {
  Question as Transformer
} from '@transformers/Question';

const state = () => ({
  mission: null,
  questions: {
    static: {
      nonRefundable: {
        label: 'label.non_refundable',
        isChecked: false,
        isRequired: true
      },
      isAnonymous: {
        label: 'label.anonymous_donation',
        isChecked: false,
        isRequired: false
      },
    },
    dynamic: {}
  }
});

const mutations = {

  /**
   * @param {object} state Stripe module states
   * @param {object} mission Mission details
   *
   * @return void
   */
  [GET_MISSION_SUCCESS]: (state, mission) => {
    state.mission = mission;
  },

  /**
   * Get mission questions on success
   *
   * @param {object} state
   * @param {object} questions
   *
   * @return void
   */
  [GET_MISSION_QUESTIONS_SUCCESS]: (state, questions) => {
    state.questions.dynamic = questions;
  },

  /**
   * Reset questions
   *
   * @param {object} state
   *
   * @return void
   */
  [RESET_QUESTIONS]: (state) => {
    state.questions = {
      static: {
        nonRefundable: {
          label: 'label.non_refundable',
          isChecked: false,
          isRequired: true
        },
        isAnonymous: {
          label: 'label.anonymous_donation',
          isChecked: false,
          isRequired: false
        },
      },
      dynamic: {}
    };
  },

};

const actions = {

  /**
   * Reset questions to default values
   *
   * @param {object} context Vuex context keys
   */
  resetQuestions({ commit }) {
    commit(RESET_QUESTIONS);
  },

  /**
   * Get mission details with the given missionId
   *
   * @param {object} context Vuex context keys
   * @param {string} missionId Id of the needed mission
   *
   * @return {promise}
   */
  async retrieveMission({ commit }, { id, query }) {
    const response = await Mission.details(id, query);
    if (response.success) {
      commit(GET_MISSION_SUCCESS, response.data);
    }
    return response;
  },

  /**
   * Get mission questions with the given missionId
   *
   * @param {object} context Vuex context keys
   * @param {string} missionId Id of the needed mission
   *
   * @return {promise}
   */
  async retrieveQuestions({ commit }, missionId) {
    const response = await Mission.getQuestions(missionId);
    if (response.success) {
      const transformer = new Transformer(
        Array.isArray(response.data)
          ? response.data
          : []
      );
      commit(GET_MISSION_QUESTIONS_SUCCESS, transformer.for('summary'));
    }
    return response;
  },

};

const getters = {};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};